<template>
  <div class="QianYu">
    <!--春季：3-5月-->
    <div class="spring" v-if="nowMoth >= 3 && nowMoth <= 5">
      <div class="banner">
        <img width="100%" src="../../../assets/img/QianYu/spring_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/QianYu/spring_huaPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/QianYu/spring_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              去汉源县前域镇——白鹤花卉种植专业合作社有客偏从陋世来，仙姿雅意费疑猜。粉红玉女通神韵，岂教风尘染两腮。
            </p>
            <p>
              走进前域镇力升家庭农场草莓育苗基地，一片绿意葱茏的草莓苗长势喜人，农场负责人高荣超正组织30余名工人忙着起苗、择苗、捆绑...这些精心挑选出来的草莓苗一部分将运回温室大棚内进行栽种，一部分将进行销售。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/QianYu/spring_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QianYu/spring_square.png')" color="#EC3942"
        borderBottomColor="#EC3942" boxBorderColor="#E1CCCD" btnBJcolor="#F29AA0" hoverBJcolor="#EC3C46">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QianYu/spring_square.png')" color="#EC3942"
        borderBottomColor="#EC3942"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/QianYu/spring_square.png')" color="#EC3942"
        borderBottomColor="#EC3942" boxBorderColor="#E1CCCD"></ztxzList>
    </div>
    <!-- 夏季：6-8月 -->
    <div class="summer" v-else-if="nowMoth >= 6 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/QianYu/summer_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/QianYu/summer_cheliziPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/QianYu/summer_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              据前域镇相关负责人介绍，果农们常年坚持使用农家肥、科学疏花疏果有效保证了水果的品质，因此果树结出的果实不仅颗粒大、水分足，口感也很好。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/QianYu/summer_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QianYu/summer_square.png')" color="#BD0000"
        borderBottomColor="#BD0000" boxBorderColor="#F6E8E9" btnBJcolor="#DD7F7D" hoverBJcolor="#C00500">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QianYu/summer_square.png')" color="#BD0000"
        borderBottomColor="#BD0000"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/QianYu/summer_square.png')" color="#BD0000"
        borderBottomColor="#BD0000" boxBorderColor="#F6E8E9"></ztxzList>
    </div>
    <!-- 秋季：9-11月 -->
    <div class="autumn" v-else-if="nowMoth >= 9 && nowMoth <= 11">
      <div class="banner">
        <img width="100%" src="../../../assets/img/QianYu/autumn_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/QianYu/autumn_liPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/QianYu/autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              据前域镇相关负责人介绍，前域镇的农作物常年坚持使用农家肥、科学疏花疏果，有效保证了品质，因此果树结出的果实不仅颗粒大、水分足，口感也很好，农作物收成也好。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/QianYu/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QianYu/autumn_square.png')" color="#D9AB00"
        borderBottomColor="#D9AB00" boxBorderColor="#F5F2E7" btnBJcolor="#E9D47B" hoverBJcolor="#DAAF00">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QianYu/autumn_square.png')" color="#D9AB00"
        borderBottomColor="#D9AB00"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/QianYu/autumn_square.png')" color="#D9AB00"
        borderBottomColor="#D9AB00" boxBorderColor="#F5F2E7"></ztxzList>
    </div>
    <!-- 冬季：1、2、12月 -->
    <div class="winter" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/QianYu/winter_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/QianYu/winter_putaoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/QianYu/winter_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              据前域镇相关负责人介绍，前域镇的农作物常年坚持使用农家肥、科学疏花疏果，有效保证了品质，因此果树结出的果实不仅颗粒大、水分足，口感也很好，农作物收成也好。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/QianYu/winter_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :imgSrc="require('../../../assets/img/QianYu/winter_square.png')" color="#569400"
        borderBottomColor="#569400" boxBorderColor="#DDE3D6" btnBJcolor="#AAC880" hoverBJcolor="#5D980A">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/QianYu/winter_square.png')" color="#569400"
        borderBottomColor="#569400"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/QianYu/winter_square.png')" color="#569400"
        borderBottomColor="#569400" boxBorderColor="#DDE3D6"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'QianYu',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'前域镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.QianYu {
  background: url('../../../../src/assets/img/QianYu/QianYu_bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.spring .top_title {
  color: #EC3942;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #EC3942;
  height: 12%;
}

.summer .top_title {
  color: #BD0000;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #BD0000;
  height: 12%;
}

.autumn .top_title {
  color: #D9AB00;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #D9AB00;
  height: 12%;
}

.winter .top_title {
  color: #569400;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #569400;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}</style>